import { Flex, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import { RowItem } from "~/features/features/components/RowItem";

import type { FeaturesProps } from "../Features";

export const FeaturesRow: FC<FeaturesProps> = (props) => {
  const { data, ...rest } = props;

  return (
    <Flex
      flexDirection="column"
      p={{ py: 40, px: 24 }}
      {...rest}
      md={{ p: { py: 80, px: 15 }, ...rest.md }}
    >
      <Title
        as="h2"
        size="medium"
        fontWeight="mobile.normal"
        lineHeight="title.mobile.large"
        horizontalAlign="center"
        m={{ mb: 24 }}
        md={{ m: { mb: 64 }, lineHeight: "title.desktop.large" }}
      >
        {data.title}
      </Title>

      <Flex
        flexDirection="column"
        align="center"
        gap={24}
        md={{
          flexDirection: "row",
          justify: "space-evenly",
          gap: 20,
          align: "flex-start",
        }}
        flexWrap="wrap"
      >
        {data.items?.map((item) => {
          const feature = item?.feature_items_id;

          return feature && <RowItem key={feature.id} {...feature} />;
        })}
      </Flex>
    </Flex>
  );
};
